import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  CircularProgress,
  Button,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";

import {
  deleteReginationRequest,
  getReginationRequestById,
  getResignationStatusById,
  updateReginationRequest,
  updateReginationRequestNoticePeriod,
} from "../../../api/resignation";
import { showAlert } from "../../../actions/alert";

import { handleAxiosError } from "../../../config/action-config";
import { getReportingMangerList } from "../../../api/employee";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import StatusProgressBar from "./resignationStatusProgressBar";

const deleteApis = {
  DELETE: deleteReginationRequest,
};

const emptyData = {
  id: "",
  employee_name: "",
  emp_id: "",
  email: "",
  contact: "",
  designation: "",
  resignation_reason: "",
  status_details: "",
  notice_period_in_days: "",
  employee_remarks: "",
  hr_remarks: "",
  last_working_day: "",
  reportingmanager: "",
  department: "",
  joining_date: "",
  employment_status: "",
  job_location: "",
};

export default function ResignationRequestView() {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [resignationRequestData, setResignationRequestData] =
    useState(emptyData);
  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });
  const [editDisabled, setEditDisabled] = useState(true);
  const [reportingManager, setReportingManagerList] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [currentStatus, setCurrentStatus] = useState("");
  const [resignationId, setResignationId] = useState("");
  const EmpId = localStorage.getItem("EmpId");
  // Function to update resignation request data
  const onresignationRequestDataUpdate = () => {
    if (resignationRequestData.notice_period_in_days === "") {
      dispatch(showAlert("Notice period is required."));
    } else {
      updateReginationRequest(
        getUpdatableData(resignationRequestData),
        user.token
      )
        .then((res) => {
          loadMasterData();
          dispatch(showAlert(res.data.msg));
          setEditDisabled(true);
        })
        .catch((err) => {
          handleAxiosError(err, dispatch);
        });
    }
  };
  const onresignationRequestNoticePeriodUpdate = () => {
    if (resignationRequestData.notice_period_in_days === "") {
      dispatch(showAlert("Notice period is required."));
    } else {
      updateReginationRequestNoticePeriod(
        getUpdatableData(resignationRequestData),
        user.token
      )
        .then((res) => {
          loadMasterData();
          dispatch(showAlert(res.data.msg));
          setEditDisabled(true);
        })
        .catch((err) => {
          handleAxiosError(err, dispatch);
        });
    }
  };
  // Function to load resignation request data
  const loadMasterData = () => {
    getReginationRequestById(params.id, user.token)
      .then((res) => {
        setResignationRequestData(res.data.data.emp_resignation[0]);
        setCurrentStatus(res.data.data.emp_resignation[0].status_details);
        setLoading(false);

        localStorage.setItem(
          "ResignationId",
          res.data.data.emp_resignation[0].id
        );
        localStorage.setItem(
          "ReportingManager",
          res.data.data.emp_resignation[0].reportingmanager
        );
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const loadResignationStatusData = () => {
    if (location.state?.emp_id) {
      localStorage.setItem("EmpId", location.state?.emp_id);
    }

    getResignationStatusById(location.state?.emp_id || EmpId, user.token)
      .then((res) => {
        let filteredData = res.data.data.filter(
          (currentItem, currentIndex, array) => {
            return (
              array.findIndex(
                (item) => item.status_details === currentItem.status_details
              ) === currentIndex
            );
          }
        );

        setStatusData(filteredData);

        setLoading(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  useEffect(() => {
    if (!params.id) {
    } else loadMasterData();
    loadResignationStatusData();
  }, [params.id]);
  useEffect(() => {
    if (!location.state?.emp_id) {
      navigate("/resignation-request");
    } else loadResignationStatusData();
  }, []);

  //   const changeUpdateData = (newValue) => {
  //     // Check if newValue is an event object
  //     if (typeof newValue === "object" && newValue.target) {
  //       // For regular input fields, use target value
  //       const { name, value } = newValue.target;
  //       setResignationRequestData((prev) => ({
  //         ...prev,
  //         [name]: value,
  //       }));
  //       // If the changed field is notice_period_in_days, calculate and set the last_working_day
  //       if (name === "notice_period_in_days") {
  //         const noticePeriod = parseInt(value);
  //         if (!isNaN(noticePeriod) && noticePeriod > 0) {
  //           const today = new Date();
  //           const lastWorkingDay = new Date(
  //             today.getTime() + noticePeriod * 24 * 60 * 60 * 1000
  //           );
  //           setResignationRequestData((prev) => ({
  //             ...prev,
  //             last_working_day: lastWorkingDay,
  //           }));
  //         } else {
  //           // If notice period is not a valid number or negative, set last working day to blank
  //           setResignationRequestData((prev) => ({
  //             ...prev,
  //             last_working_day: null,
  //           }));
  //         }
  //       }
  //     } else {
  //       // For date pickers or other inputs directly passing value
  //       setResignationRequestData((prev) => ({
  //         ...prev,
  //         last_working_day: newValue,
  //       }));
  //     }
  //   };
  const changeUpdateData = (newValue) => {
    // Check if newValue is an event object
    if (typeof newValue === "object" && newValue.target) {
      // For regular input fields, use target value
      const { name, value } = newValue.target;
      setResignationRequestData((prev) => ({
        ...prev,
        [name]: value,
      }));
      // If the changed field is notice_period_in_days, calculate and set the last_working_day
      if (name === "notice_period_in_days") {
        const noticePeriod = parseInt(value);
        if (!isNaN(noticePeriod) && noticePeriod > 0) {
          const today = new Date();
          const lastWorkingDay = new Date(
            today.getTime() + noticePeriod * 24 * 60 * 60 * 1000
          );
          setResignationRequestData((prev) => ({
            ...prev,
            last_working_day: lastWorkingDay,
          }));
        } else {
          // If notice period is not a valid number or negative, set last working day to blank
          setResignationRequestData((prev) => ({
            ...prev,
            last_working_day: null, // or you can set it to an empty string ''
          }));
        }
      }
      // If the status_details is "Retention", set notice_period_in_days to 0
      if (name === "status_details" && value === "false") {
        setResignationRequestData((prev) => ({
          ...prev,
          notice_period_in_days: 0,
        }));
        // Set last_working_day to blank when notice period is set to 0
        setResignationRequestData((prev) => ({
          ...prev,
          last_working_day: null, // or ''
        }));
      }
    } else {
      // For date pickers or other inputs directly passing value
      setResignationRequestData((prev) => ({
        ...prev,
        last_working_day: newValue,
      }));
    }
  };

  const onDelete = () => {
    const deleteApi = deleteApis[deletingContent.table];
    deleteApi(deletingContent.row, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeletingContent({ type: "", row: 0 });
        if (deletingContent.table === "DELETE") {
          navigate("/resignation-request");
        }
      })
      .catch((err) => {
        setDeletingContent({ table: "", row: 0 });
        handleAxiosError(err, dispatch);
      });
  };
  useEffect(() => {
    reportingManagerList();
  }, []);

  const reportingManagerList = async () => {
    const token = user.token;
    return getReportingMangerList(token).then((res) => {
      setReportingManagerList(res.data.data.roledata);
    });
  };
  return loading ? (
    <Loading />
  ) : (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Resignation Request Details</Typography>
          <Box sx={{ display: "flex", columnGap: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                navigate("/resignation-request");
              }}
              style={{ padding: "5px 7px" }}
            >
              Go Back
            </Button>
            {/* <Button
              variant="contained"
              onClick={() => {
                setDeletingContent({
                  table: "DELETE",
                  row: resignationRequestData.id,
                });
              }}
            >
              Delete
            </Button> */}
          </Box>
        </Box>
        <StatusProgressBar  lastWorkingDay={resignationRequestData.last_working_day} data={statusData} />
        <Grid container columnSpacing={2} rowSpacing={1} sx={{ pt: "1rem" }}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              autoFocus
              disabled
              id="employee_name"
              name="employee_name"
              label="Employee Name"
              fullWidth
              value={resignationRequestData.employee_name}
              onChange={changeUpdateData}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              id="email"
              name="email"
              label="Email"
              fullWidth
              value={resignationRequestData.email}
              onChange={changeUpdateData}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              id="contact"
              name="contact"
              label="Contact"
              fullWidth
              value={resignationRequestData.contact}
              onChange={changeUpdateData}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              margin="dense"
              id="designation"
              name="designation"
              label="Designation"
              fullWidth
              value={resignationRequestData.designation}
              onChange={changeUpdateData}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              margin="dense"
              id="department"
              name="department"
              label="Department"
              fullWidth
              value={resignationRequestData.department}
              onChange={changeUpdateData}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              margin="dense"
              id="joining_date"
              name="joining_date"
              label="Joining Date"
              fullWidth
              value={formatDateToYYYYMMDD(resignationRequestData.joining_date)}
              onChange={changeUpdateData}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              margin="dense"
              id="employment_status"
              name="employment_status"
              label="Employment Status"
              fullWidth
              value={resignationRequestData.employment_status}
              onChange={changeUpdateData}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              margin="dense"
              id="job_location"
              name="job_location"
              label="Job Location"
              fullWidth
              value={resignationRequestData.job_location}
              onChange={changeUpdateData}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              margin="dense"
              id="reportingmanager"
              name="reportingmanager"
              label="Reporting Manager"
              fullWidth
              value={resignationRequestData.reportingmanager}
              onChange={changeUpdateData}
            />
          </Grid>

          {/* <Grid item xs={12} sm={6} md={6} lg={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Reporting Manager
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                name="reportingmanager"
                id="demo-simple-select"
                value={resignationRequestData.reportingmanager}
                onChange={changeUpdateData}
                label="Reporting Manager"
                disabled={editDisabled}
              >
                <MenuItem value="">Select</MenuItem>
                {reportingManager.map((r, i) => (
                  <MenuItem key={i} value={r.email}>
                    {r.email}
                  </MenuItem>
                ))}
                <MenuItem value="None">None</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}
          {/* {resignationRequestData.status_details === "RESIGNATION_REQUESTED" ? (
            <Grid item xs={12} md={6} lg={4}>
              <FormControl fullWidth margin="dense">
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                  labelId="status-label"
                  id="status_details"
                  name="status_details"
                  disabled
                  value={resignationRequestData.status_details}
                  onChange={changeUpdateData}
                >
                  <MenuItem value="PENDING">Pending</MenuItem>
                  <MenuItem value="ACCEPT">Accept</MenuItem>
                  <MenuItem value="RETAIN">Retain</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          ) : ( */}
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              margin="dense"
              id="status_details"
              name="status_details"
              label="Status"
              disabled
              fullWidth
              value={resignationRequestData.status_details}
            />
          </Grid>
          {/* )} */}

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              margin="dense"
              id="notice_period_in_days"
              name="notice_period_in_days"
              label="Notice Period (in days)"
              fullWidth
              value={resignationRequestData.notice_period_in_days}
              onChange={changeUpdateData}

              // disabled={
              //   resignationRequestData.status_details === "RETAIN"
              //     ? true
              //     : false
              // }
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl margin="dense" fullWidth>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  disabled
                  value={resignationRequestData.last_working_day}
                  onChange={(newValue) =>
                    setResignationRequestData((prev) => ({
                      ...prev,
                      last_working_day: newValue,
                    }))
                  }
                  label="Last Working Day"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // error={Boolean(errors.last_working_day)}
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              margin="dense"
              id="employee_remarks"
              name="employee_remarks"
              label="Employee Remarks"
              fullWidth
              multiline
              rows={4}
              value={resignationRequestData.employee_remarks}
              onChange={changeUpdateData}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              disabled
              margin="dense"
              id="resignation_reason"
              name="resignation_reason"
              label="Reason for Resignation"
              fullWidth
              multiline
              rows={4}
              value={resignationRequestData.resignation_reason}
              onChange={changeUpdateData}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              margin="dense"
              id="hr_remarks"
              name="hr_remarks"
              label="HR Remarks"
              fullWidth
              multiline
              rows={4}
              value={resignationRequestData.hr_remarks}
              onChange={changeUpdateData}
            />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              columnGap: 1,
              ml: "auto",
            }}
          >
            <Button
              disabled={/^Trial_User$/i.test(user.role) ? true : false}
              variant="contained"
              onClick={onresignationRequestNoticePeriodUpdate}
              style={{ padding: "5px 7px" }}
              className="blue-button"
            >
              UPDATE
            </Button>
          </Box>
        </Grid>
      </Paper>

      <DeleteDialog
        deletingContent={deletingContent}
        setDeletingContent={setDeletingContent}
        onDelete={onDelete}
      />
    </Box>
  );
}

function DeleteDialog({ deletingContent, setDeletingContent, onDelete }) {
  return (
    <Dialog
      open={Boolean(deletingContent.table)}
      onClose={() => {
        setDeletingContent({ table: "", row: 0 });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This will delete the row in table {deletingContent.table} with id:{" "}
          {deletingContent.row}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDeletingContent({ table: "", row: 0 });
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button onClick={onDelete} autoFocus className="blue-button">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}

function getUpdatableData(data) {
  return {
    id: data.id,
    emp_id: data.emp_id,
    // request_status: data.status_details,
    status_remarks: data.hr_remarks,
    notice_period_in_days: data.notice_period_in_days,
    last_working_day: data.last_working_day,
  };
}
function formatDateToYYYYMMDD(isoDateString) {
  if (!isoDateString) return ""; // Return empty string if input is falsy

  const datePortion = isoDateString.split("T")[0];
  return datePortion;
}
